import { FC } from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

type Variant = 'standalone' | 'tooltip'

const variantPaddingLeft = (variant: Variant) => {
  switch (variant) {
    case 'standalone':
      return '30px'
    case 'tooltip':
      return '16px'
    default:
      return '30px'
  }
}

const variantMargin = (variant: Variant) => {
  switch (variant) {
    case 'standalone':
      return '15px 0 0 0'
    case 'tooltip':
      return '0'
    default:
      return '15px 0 0 0'
  }
}

const PrimaryList = styled('ul')<{ variant: Variant }>`
  margin: ${(props) => variantMargin(props.variant)};
  padding-left: ${(props) => variantPaddingLeft(props.variant)};
`

const ListItem = styled('li')`
  & + & {
    margin-top: 10px;
  }
`

const ListItemValue = styled(Typography)`
  font-weight: normal;
`

const RegistrantNotice: FC<{ variant?: Variant }> = ({ variant }) => (
  <PrimaryList variant={variant || 'standalone'}>
    <ListItem>
      <ListItemValue variant="body1">Registration is ONLY for participants or their guardians.</ListItemValue>
    </ListItem>
    <ListItem>
      <ListItemValue variant="body1">
        If you simply want to support, please ask the participant for their shopping link.
      </ListItemValue>
    </ListItem>
  </PrimaryList>
)

export default RegistrantNotice
